export default __webpack_public_path__ + "static/media/Metropolis-SemiBold.fd456746.woff";